export const MAX_FILE_SIZE = 20 * 1024 * 1024 // 20 MB

export const MAX_ATTACHMENT_NAME_LIMIT = 30

// Supported file types for preview
export const PREVIEWABLE_FILE_TYPES = {
  IMAGE: [
    '.jpg',
    '.jpeg',
    '.png',
    '.gif',
    '.bmp',
    '.webp',
    '.svg',
    '.heic',
    '.jfif'
  ],
  VIDEO: ['.mp4', '.mov', '.avi', '.webm', '.mkv'],
  AUDIO: ['.wav', '.mp3', '.ogg', '.m4a', '.aac'],
  PDF: ['.pdf'],
  TEXT: ['.txt', '.rtf', '.md', '.json', '.xml', '.csv'],
  SPREADSHEET: ['.xlsx', '.xls']
}

// File type categories
export const FILE_CATEGORIES = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  PDF: 'pdf',
  TEXT: 'text',
  DOCUMENT: 'document',
  SPREADSHEET: 'spreadsheet',
  PRESENTATION: 'presentation',
  OTHER: 'other'
}

export const ALLOWED_FILE_TYPES = ['image', 'video', 'audio', 'pdf', 'text']
